import { queryOptions } from '@tanstack/react-query';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

/** The store's resolved chat settings; the route loader prefetches it. */
export function chatSettingsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: chatSettingsKeys.settings(storeId),
    queryFn: () => chatSettingsApi.settings(storeId),
  });
}
